// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperNewsStory-cls1___e366cd72087fa09d9bc","cls2":"MultiPaperNewsStory-cls2___7035378745ecd21d61f MultiPaperNewsStory-cls1___e366cd72087fa09d9bc"};